import { render, staticRenderFns } from "./orderDetailListReport.vue?vue&type=template&id=0ddfd855&scoped=true&%3Avisible.sync=addOwnerShow&%3Atitle=title&"
import script from "./orderDetailListReport.vue?vue&type=script&lang=js&"
export * from "./orderDetailListReport.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailListReport.vue?vue&type=style&index=0&id=0ddfd855&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddfd855",
  null
  
)

export default component.exports